import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../../assets/img/logo.svg";

export default function Header() {
  const [burgerOpen, setBurgerOpen] = useState(false);

	const [position, setPosition] = useState(window.scrollY)
	const [moved, setMoved] = useState(false) 
	const [reload, setReload] = useState(window.location.pathname)


	if(reload !== window.location.pathname) {
		console.log('hgjhjg');
		setMoved(position > 10)
		setReload(window.location.pathname)
	}

	useEffect(()=> {
			const handleScroll = () => {
				let moving = window.scrollY
				setPosition(moving)
				setMoved(position > 10)
			};
			window.addEventListener("scroll", handleScroll);
			return(() => {
				window.removeEventListener("scroll", handleScroll);
			})
	})

	console.log(position);
	console.log(moved);
	


  return (
    <header className={`header ${moved ? 'moved': '' }`}>
      <div className="header__container">
        <Link to={'.'} className="header__logo">
					<img src={logo} alt=""></img>
				</Link>
        <div className={`header__nav nav ${burgerOpen ? "open" : ""}`}>
          <nav className="nav__body">
            <NavLink to={'.'} className="nav__link">HOME</NavLink>
            <NavLink to={'sale'} className="nav__link">SALE</NavLink>
            <NavLink to={'wypozyczalnia'} className="nav__link">Wypożyczalnia</NavLink>
          </nav>
        </div>
        <button
          type="button"
          onClick={({}) => setBurgerOpen(!burgerOpen)}
          className={`nav__icon icon-menu ${burgerOpen ? "menu-open" : ""}`}
        >
          <span></span>
        </button>
      </div>
    </header>
  );
}
